import { styled } from '@mui/material';

import { Skeleton } from '../../atoms/Skeleton';
import { MEETING_LIST_WIDE_QUERY, MEETING_TILE_SIZE } from '../MeetingList/meetingListContainer';

const Row = styled('li')(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: `${MEETING_TILE_SIZE}px minmax(0, 1fr)`,
  columnGap: theme.spacing(1.5),
  alignItems: 'center',
  minHeight: theme.spacing(9),
  paddingBlock: theme.spacing(1.5),
  paddingInline: theme.spacing(2),
  [MEETING_LIST_WIDE_QUERY]: {
    columnGap: theme.spacing(2),
    minHeight: theme.spacing(8),
    paddingBlock: theme.spacing(1),
  },
}));

const Lines = styled('span')({
  display: 'flex',
  flexDirection: 'column',
  minWidth: 0,
});

/** Placeholder mirroring a `MeetingListItem` while the register loads. */
export function MeetingListItemSkeleton() {
  return (
    <Row aria-hidden="true">
      <Skeleton variant="rounded" width={MEETING_TILE_SIZE} height={MEETING_TILE_SIZE} />
      <Lines>
        <Skeleton variant="text" width="40%" />
        <Skeleton variant="text" width="60%" />
      </Lines>
    </Row>
  );
}
